import logo from '../../assets/images/main_logo.png';

export const authenticationContent = {
    "logo": {
        "src": logo,
        "alt": "Lumi Ads Logo",
    },
    'signIn': {
        "title": "Welcome Back!",
        "login": {
            "signup_prompt": "New to Lumi Ads?",
            "signup_button_text": "Sign Up"
        },
        'SignUpPrompt': {
            'title': 'New to Lumi Ads?',
            'btn_text': 'Sign Up'
        }
    },
    'signUp': {
        'title': 'Create a New Account',
        'description': "Let's start with your mobile number.",
        "leftPanel": {
            "title": "Sign Up on Lumi Ads",
            "description": "An exclusive marketplace for all your wedding essentials.",
            "cta": {
                "text": "Already have an account?",
                "button": {
                    "label": "Sign In",
                    "action": "redirect_to_sign_in"
                }
            }
        }
    },
    "continue_button_text": "Continue",
    "helpSection": {
        "text": "Need help?",
        "links": [{
                "label": "Contact Us",
                "url": "URL_to_contact_us_page"
            },
            {
                "label": "Privacy & Terms",
                "url": "URL_to_privacy_and_terms_page"
            }
        ]
    },
    "image": {
        "src": "promo-image-url",
        "alt": "Promo image showcasing Lumi Ads features"
    }
}